export default "__VITE_ASSET__C6gt$bpu__"